<template>
  <el-date-picker
    ref="datePicker"
    v-model="value"
    v-bind="params.props"
    @blur="onBlur"
  />
</template>

<script>
import Vue from 'vue'
import TableKeyboardNav from '@/mixin/TableKeyboardNav'

export default Vue.extend({
  name: 'CargoAgGridDateTimeEditor',
  mixins: [TableKeyboardNav],
  data() {
    return {
      value: ''
    }
  },
  mounted() {
    this.value = this.params.value
    this.$nextTick(() => {
      if (this.$refs.datePicker) {
        this.$refs.datePicker.focus()
      }
    })
  },
  methods: {
    //
    getValue() {
      return this.value
    },
    onVisibleChange(value) {
      if (!value) {
        this.params.api.stopEditing()
      }
    },
    onBlur() {
      console.log('input-stop',)
      this.params.api.stopEditing()
    }
  }
})
</script>

<style>
</style>
